import i18n from "@/i18n";
import { driver } from "driver.js";
import "driver.js/dist/driver.css";

// IMPORTANT: This way of calling t is the only way to make it work for DriverJS, because you can't pass t as a parameter to this tour_object.
// The only known issue with this approach is that it won't change its translations when the language has been changed in the account settings. This is fine for the moment, but this opinion can change in the future when the tour_object is used more frequently.
// Because the tour_object is only shown once on the Homepage, and is rarely accessed on the Features & Bugs page, this can stay like this for now.
const t = i18n.t;

const tour_object = driver({
	doneBtnText: t("driver_tour.done"),
	nextBtnText: `${t("driver_tour.next")} →`,

	onDestroyStarted: () => {
		if (!tour_object.hasNextStep() || confirm(t("driver_tour.close"))) {
			// Close the tour
			tour_object.destroy();
		}
	},
	prevBtnText: `← ${t("driver_tour.previous")}`,
	showButtons: true,
	showProgress: true,
});

export default tour_object;
